/**
 * Support Ticket Modal
 * Submits by triggering Shopify's own rendered contact form (with hCaptcha baked in).
 */
(function () {
  'use strict';

  // ── Move modals to <body> ───────────────────────────────────────────────────
  function hoistModals() {
    document.querySelectorAll('[data-support-ticket-modal]').forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  // ── Move hCaptcha widget from hidden Shopify form into visible modal ─────────
  // hCaptcha won't initialise inside display:none, so the hidden form is kept
  // offscreen. Once it renders, we move the widget into the modal's placeholder.
  function hoistCaptchaWidgets() {
    document.querySelectorAll('[data-support-ticket-captcha]').forEach(function (placeholder) {
      var blockId   = placeholder.dataset.supportTicketCaptcha;
      var shopifyForm = document.getElementById('support-ticket-shopify-form-' + blockId);
      if (!shopifyForm) return;
      var widget = shopifyForm.querySelector('.h-captcha, [data-hcaptcha-widget-id], iframe[src*="hcaptcha"]');
      if (widget) {
        placeholder.appendChild(widget);
      }
    });
  }

  // ── Open / Close ────────────────────────────────────────────────────────────
  function openModal(modal) {
    modal.hidden = false;
    modal.getBoundingClientRect();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var first = modal.querySelector('input, select, textarea, button');
    if (first) first.focus();
    trapFocus(modal);
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    releaseFocus(modal);
    var done = false;
    function finish() { if (done) return; done = true; modal.hidden = true; }
    modal.addEventListener('transitionend', function h() { modal.removeEventListener('transitionend', h); finish(); });
    setTimeout(finish, 400);
  }

  // ── Focus trap ──────────────────────────────────────────────────────────────
  var FOCUSABLE = 'a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function trapFocus(el) {
    el._stTrap = function (e) {
      if (e.key !== 'Tab') return;
      var nodes = Array.from(el.querySelectorAll(FOCUSABLE));
      if (!nodes.length) return;
      if (e.shiftKey) { if (document.activeElement === nodes[0]) { e.preventDefault(); nodes[nodes.length-1].focus(); } }
      else            { if (document.activeElement === nodes[nodes.length-1]) { e.preventDefault(); nodes[0].focus(); } }
    };
    el._stEsc = function (e) { if (e.key === 'Escape') closeModal(el); };
    document.addEventListener('keydown', el._stTrap);
    document.addEventListener('keydown', el._stEsc);
  }
  function releaseFocus(el) {
    if (el._stTrap) document.removeEventListener('keydown', el._stTrap);
    if (el._stEsc)  document.removeEventListener('keydown', el._stEsc);
  }

  // ── Validation ──────────────────────────────────────────────────────────────
  function validateForm(form) {
    var valid = true;
    form.querySelectorAll('[required]').forEach(function (field) {
      field.classList.remove('is-invalid');
      var val = field.value.trim();
      if (!val) { field.classList.add('is-invalid'); valid = false; }
      else if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) { field.classList.add('is-invalid'); valid = false; }
    });
    return valid;
  }

  // ── Submission ──────────────────────────────────────────────────────────────
  // Strategy: copy user inputs into Shopify's own hidden {% form 'contact' %} form
  // and submit it. Shopify has already injected hCaptcha into that form, so it
  // passes spam protection without us needing to touch the captcha at all.

  function submitTicket(visibleForm, blockId) {
    var errorEl    = document.querySelector('[data-support-ticket-error="'   + blockId + '"]');
    var successEl  = document.querySelector('[data-support-ticket-success="' + blockId + '"]');
    var submitBtn  = visibleForm.querySelector('.support-ticket-modal__submit');
    var submitText = visibleForm.querySelector('.support-ticket-modal__submit-text');
    var submitSpin = visibleForm.querySelector('.support-ticket-modal__submit-loading');

    if (!validateForm(visibleForm)) {
      if (errorEl) { errorEl.textContent = 'Please fill in all required fields correctly.'; errorEl.hidden = false; }
      return;
    }
    if (errorEl) errorEl.hidden = true;

    // Loading state
    if (submitText) submitText.hidden = true;
    if (submitSpin) submitSpin.hidden = false;
    if (submitBtn)  submitBtn.disabled = true;

    // Get values from visible form
    var name    = visibleForm.querySelector('[name="name"]').value.trim();
    var email   = visibleForm.querySelector('[name="email"]').value.trim();
    var typeEl  = visibleForm.querySelector('[name="query_type"]');
    var type    = typeEl ? typeEl.options[typeEl.selectedIndex].text : '';
    var message = visibleForm.querySelector('[name="message"]').value.trim();
    var body    = '[' + type + ']\n\n' + message;

    // Find the hidden Shopify form
    var shopifyForm = document.getElementById('support-ticket-shopify-form-' + blockId);
    if (!shopifyForm) {
      showError(errorEl, submitBtn, submitText, submitSpin, 'Form not found. Please refresh the page.');
      return;
    }

    // Copy values into the Shopify form fields
    setHiddenInput(shopifyForm, 'contact[name]',  name);
    setHiddenInput(shopifyForm, 'contact[email]', email);
    setHiddenInput(shopifyForm, 'contact[body]',  body);

    // Listen for Shopify's redirect / response after submit
    // Shopify redirects back to the same page with ?contact%5Bposted_successfully%5D=true
    // We intercept by catching the fetch response on the form's action

    var formData = new FormData(shopifyForm);
    // Ensure our values override anything already in the form
    formData.set('contact[name]',  name);
    formData.set('contact[email]', email);
    formData.set('contact[body]',  body);

    // Pick up hCaptcha token — the widget may have been moved into the modal,
    // so check both the modal and the hidden form for the response textarea.
    var modal = document.querySelector('[data-support-ticket-modal="' + blockId + '"]');
    var captchaToken = '';
    var captchaEl = (modal && modal.querySelector('[name="h-captcha-response"]'))
                 || shopifyForm.querySelector('[name="h-captcha-response"]');
    if (captchaEl) captchaToken = captchaEl.value || '';
    if (captchaToken) formData.set('h-captcha-response', captchaToken);

    fetch(shopifyForm.action || '/contact', {
      method:  'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json, text/html' },
      body:    formData
    })
    .then(function (res) {
      // Shopify returns 200 on success (AJAX) or 302 redirect.
      // fetch follows redirects automatically; a 200 back on the contact page means success.
      // Check URL or response text for success indicator.
      if (res.ok) {
        return res.text().then(function (html) {
          // Shopify success page contains this string
          if (html.indexOf('posted_successfully') !== -1 || html.indexOf('contact%5Bposted_successfully%5D=true') !== -1 || res.url.indexOf('posted_successfully') !== -1) {
            showSuccess(visibleForm, successEl, submitBtn, submitText, submitSpin);
          } else {
            // Still treat 200 as success — Shopify doesn't always add the flag for AJAX
            showSuccess(visibleForm, successEl, submitBtn, submitText, submitSpin);
          }
        });
      } else {
        throw new Error('HTTP ' + res.status);
      }
    })
    .catch(function (err) {
      console.error('Support ticket error:', err);
      showError(errorEl, submitBtn, submitText, submitSpin, 'Something went wrong. Please try again.');
    });
  }

  function showSuccess(form, successEl, btn, text, spin) {
    form.hidden = true;
    if (successEl) successEl.hidden = false;
    if (text) text.hidden = false;
    if (spin) spin.hidden = true;
    if (btn)  btn.disabled = false;
  }

  function showError(errorEl, btn, text, spin, msg) {
    if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
    if (text) text.hidden = false;
    if (spin) spin.hidden = true;
    if (btn)  btn.disabled = false;
  }

  function setHiddenInput(form, name, value) {
    var el = form.querySelector('[name="' + name + '"]');
    if (el) {
      el.value = value;
    } else {
      var input = document.createElement('input');
      input.type  = 'hidden';
      input.name  = name;
      input.value = value;
      form.appendChild(input);
    }
  }

  // ── Init ────────────────────────────────────────────────────────────────────
  function init() {
    hoistModals();

    // Wait briefly for hCaptcha to render its widget, then move it into the modal.
    // hCaptcha renders asynchronously after DOMContentLoaded.
    function tryHoistCaptcha(attempts) {
      hoistCaptchaWidgets();
      var allMoved = true;
      document.querySelectorAll('[data-support-ticket-captcha]').forEach(function (ph) {
        if (!ph.querySelector('iframe, .h-captcha')) allMoved = false;
      });
      if (!allMoved && attempts > 0) {
        setTimeout(function () { tryHoistCaptcha(attempts - 1); }, 300);
      }
    }
    setTimeout(function () { tryHoistCaptcha(20); }, 200);

    document.querySelectorAll('[data-support-ticket-trigger]').forEach(function (trigger) {
      var blockId = trigger.dataset.supportTicketTrigger;
      var modal   = document.querySelector('[data-support-ticket-modal="' + blockId + '"]');
      if (!modal) return;
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        openModal(modal);
      });
    });

    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-support-ticket-close]');
      if (!el) return;
      // Stop propagation so MenuDrawer.onCloseButtonClick doesn't fire and
      // try to call .closest('details') on a button outside a <details> element.
      e.stopPropagation();
      var modal = document.querySelector('[data-support-ticket-modal="' + el.dataset.supportTicketClose + '"]');
      if (modal) closeModal(modal);
    });

    document.querySelectorAll('[data-support-ticket-form]').forEach(function (form) {
      var blockId = form.dataset.supportTicketForm;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitTicket(form, blockId);
      });
      form.querySelectorAll('[required]').forEach(function (field) {
        field.addEventListener('input', function () { field.classList.remove('is-invalid'); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();